<div class="purchased-vouchers">
  <ng-container *ngIf="loading || displayedVouchers.length > 0; else noPurchasedVouchers">
    <air-table class="purchased-vouchers__table" [loading]="loading">
      <air-table-heading>{{ "voucher.label.product" | translate }}</air-table-heading>
      <air-table-heading>{{ "general.label.valid_until" | translate }}</air-table-heading>
      <air-table-heading>{{ "general.label.actions" | translate }}</air-table-heading>
      <ng-container air-table-body>
        <ng-container *ngFor="let orderVoucher of displayedVouchers">
          <tr class="table__row--supplier">
            <td colspan="2">
              <h5>{{ orderVoucher.partnerName }}</h5>
            </td>
            <td>
              <a
                *ngIf="orderVoucher.showGenerateLink"
                class="button button--tertiary button--sm"
                (click)="triggerRedeliverVouchers(orderVoucher, $event)"
              >
                {{ "voucher.label.generate_vouchers" | translate }}
              </a>
            </td>
          </tr>
          <tr *ngFor="let voucher of orderVoucher.vouchers" [ngClass]="{ 'table__row--expired': voucher.expired }">
            <td>{{ voucher.description }}</td>
            <td>
              <div class="purchased-vouchers__validity">
                <span *ngIf="voucher.validity">{{ voucher.validity | date: "dd-MM-yyyy" }}</span>
                <span *ngIf="voucher.expired" class="badge badge--grey">{{ "general.label.expired" | translate }}</span>
              </div>
            </td>
            <td>
              <a
                class="button button--primary button--sm"
                [class.d--hidden]="!voucher.downloadUrl"
                (click)="downloadClick($event)"
                href="{{ voucher.downloadUrl }}"
                target="_system"
              >
                {{ "voucher.label.download_voucher" | translate }}
              </a>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </air-table>
    <div class="purchased-vouchers__load-more">
      <button *ngIf="numberDisplayed < vouchers.length" (click)="displayMoreVouchers()" class="button button--border">
        {{ "general.label.load_more" | translate }}
      </button>
    </div>
  </ng-container>
  <ng-template #noPurchasedVouchers>
    <air-action-text [actionText]="content.emptyState" [userEventSource]="userEventSource"></air-action-text>
  </ng-template>
</div>
